import React, { Component } from 'react';
import InfinityLoader from '../../../assets/svg/infinityLoader';
import _ from 'lodash';

class LoadingBar extends Component {
	render() {
		return (
			<div id="loading">
				<InfinityLoader />
			</div>
		);
	}
}
export default LoadingBar;
